<template>
  <iframe @load="onLoad">
    <slot> </slot>
  </iframe>
</template>

<script>
import Vue from "vue";
import { customLogger } from "@/utils";

export default {
  name: "IFrame",
  beforeUpdate() {
    // customLogger("update triggered");
    //freezing to prevent unnessessary Reactifiation of vNodes
    this.iApp.children = Object.freeze(this.$slots.default);
  },
  methods: {
    onLoad() {
      // customLogger("load triggered");
      this.renderChildren();
    },
    renderChildren() {
      const children = this.$slots.default;
      const body = this.$el.contentDocument.body;

      const el = document.createElement("DIV"); // we will mount or nested app to this element
      body.appendChild(el);

      // hot reload of I18n module

      const iApp = new Vue({
        name: "IApp",
        //freezing to prevent unnessessary Reactifiation of vNodes
        eb: this.$eb,
        i18n: this.$i18n,
        store: this.$store,
        data: { children: Object.freeze(children) },
        render(h) {
          return h("div", this.children);
        },
      });
      iApp.$mount(el); // mount into iframe

      this.iApp = iApp; // cache instance for later updates
    },
  },
};
</script>
